export const reactRouterFutureFlags = {
  // Enabled all future flags for v7 upgrade: https://reactrouter.com/6.29.0/upgrading/future
  v7_fetcherPersist: true,
  v7_normalizeFormMethod: true,
  v7_partialHydration: true,
  v7_relativeSplatPath: true,
  v7_skipActionErrorRevalidation: true,
};
